import { AbstractEntityMapper } from '@pf/shared-services';
import {
    ZoneCreate,
    ZoneDto,
    ZoneRead,
    ZoneSearchParams,
} from '../../entities/zone.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { ZoneMetadataMap } from './zone.mapping-profile';

@Injectable()
export class ZoneMapper extends AbstractEntityMapper<
    ZoneRead,
    ZoneCreate,
    ZoneDto,
    ZoneSearchParams
> {
    constructor() {
        super(ZoneDto, PlatformWmsMapper, ZoneMetadataMap.symbols);
    }
}
